import Vue from "vue";
import VueRouter from "vue-router";

// import HomePage from '@/views/HomePage';
Vue.use(VueRouter);
// ReviewCriterion
const router = new VueRouter({
  routes: [
    {
      path: "/",
      name: "home",
      redirect: { name: "homepage" },
      component: () => import("@/views/HomePage"),
    },
    {
      path: "/problem",
      name: "problem",
      component: () => import("@/views/Problem"),
    },
    {
      path: "/detail",
      name: "detail",
      component: () => import("@/views/Detail"),
    },
    {
      path: "/home",
      name: "homepage",
      component: () => import("@/views/HomePage"),
    },

    {
      path: "/reviewcriterion",
      name: "reviewcriterion",
      component: () => import("@/views/ReviewCriterion"),
    },
    {
      path: "/reviewtechnology",
      name: "reviewtechnology",
      component: () => import("@/views/ReviewTechnology"),
    },
    {
      path: "/news",
      name: "news",
      component: () => import("@/views/News"),
    },
    {
      path: "/aboutexamination",
      name: "aboutexamination",
      redirect: { name: "orgnazition" },
      component: () => import("@/views/AboutExamination"),
      children: [
        {
          path: "examinationtype",
          name: "examinationtype",
          component: () => import("@/views/ExaminationType"),
        },
        {
          path: "examinationexplain",
          name: "examinationexplain",
          component: () => import("@/views/ExaminationExplain"),
        },
        {
          path: "download",
          name: "download",
          component: () => import("@/views/Download"),
        },
        {
          path: "point",
          name: "point",
          component: () => import("@/views/Point"),
        },
        {
          path: "orgnazition",
          name: "orgnazition",
          component: () => import("@/views/Orgnazition"),
        },
        {
          path: "mechanism",
          name: "mechanism",
          component: () => import("@/views/Mechanism"),
        },
      ],
    },
  ],
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
